import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m5 8 6 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4 14 6-6 2-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 5h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 2h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 22-5-10-5 10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 18h6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Languages";
const Languages = memo(themed(Icon));
export {
  Languages
};
//# sourceMappingURL=languages.js.map
